import AdminLiveDisputesPage from '../../../components/admin/disputes/AdminLiveDisputesPage'

export default function Disputes() {
  return <AdminLiveDisputesPage />
}
